
import { Page } from 'web-mojo';

export default class HomePage extends Page {
    constructor(options = {}) {
        super({
            title: 'Home',
            pageName: "home",
            route: "home",
            template: `
                <div class="container">
                    <h1>Welcome {{app.activeUser.display_name}}</h1>
                    <p>Welcome to the CAMACTIVE Portal.  Please select your Organization or Group.</p>
                </div>
            `,
            ...options
        });
    }

    async onEnter() {
        await super.onEnter();

        const app = this.getApp();
        // Your custom logic here
        if (app.activeGroup) {
            // Perform actions specific to the active group
            setTimeout(() => {
                app.sidebar.showMenuForGroup(app.activeGroup);
            }, 50);
        } else {
            setTimeout(() => {
                app.sidebar.showGroupSearch();
            }, 50);

        }
    }
}
